import React, { useEffect, useState } from "react";
import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { CloseOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/CloseOutlined";
import { WishlistFilled } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/WishlistFilled";
import { IconButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/IconButton";
import { dispatchMonetateQEvent } from "@/utils/monetate/monetateQ.ts";
import classnames from "classnames/bind";

import styles from "./WishlistConfirmation.module.scss";

const cx = classnames.bind(styles);

export const WISHLIST_CONFIRMATION_LINK_CLICK_EVENT_KEY =
  "wishlist_confirmation_link_click";
export const WISHLIST_CONFIRMATION_CLOSE_EVENT_KEY =
  "wishlist_confirmation_close";

type Props = {
  addedToWishlist: boolean;
  addedToMultipleWishlists: boolean;
  variantId: string;
  accountBaseUrl: string;
};

export const WishlistConfirmation = ({
  addedToWishlist,
  addedToMultipleWishlists,
  variantId,
  accountBaseUrl,
}: Props) => {
  const [isOpen, setIsOpen] = useState(true);

  const handleCloseClick = () => {
    dispatchMonetateQEvent(WISHLIST_CONFIRMATION_CLOSE_EVENT_KEY);

    setIsOpen(false);
  };

  const handleLinkClick = () => {
    dispatchMonetateQEvent(WISHLIST_CONFIRMATION_LINK_CLICK_EVENT_KEY);

    window.location.assign(`${accountBaseUrl}/wish-list`);
  };

  useEffect(() => {
    setIsOpen(true);
  }, [variantId]);

  if (!isOpen || !addedToWishlist) return null;

  return (
    <div
      className={cx("wishlistTooltipContainer")}
      data-testid="wishlist-confirmation-tooltip"
    >
      <div className={cx("wishlistTooltip")}>
        <span>
          <WishlistFilled size="medium" />
          View your
          <UnderlinedButton
            className={cx("wishlistTooltipLink")}
            onClick={handleLinkClick}
            data-testid="wishlist-confirmation-tooltip:link"
          >
            {addedToMultipleWishlists ? "wish lists" : "wish list"}
          </UnderlinedButton>
        </span>
        <IconButton
          IconComponent={<CloseOutlined size="medium" />}
          variant="clear-dark"
          className={cx("wishlistButton")}
          onClick={handleCloseClick}
          data-testid="wishlist-confirmation-tooltip:close-button"
        />
      </div>
    </div>
  );
};
